import { render, staticRenderFns } from "./CatalogueIdeas.vue?vue&type=template&id=61899cc2"
import script from "./CatalogueIdeas.vue?vue&type=script&lang=js"
export * from "./CatalogueIdeas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports